'use client';

import { fromJS } from 'immutable';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

import { trackEvent } from '@/lib/event_tracker';

function PageView({ sessionData, pageType, properties, skipPageView }) {
  const [trackedPageView, setTrackedPageView] = useState(null);
  const pathname = usePathname();

  const session = fromJS(sessionData);

  useEffect(() => {
    if (skipPageView) {
      return () => {
        // Do nothing.
      };
    }

    if (trackedPageView === pathname) {
      return () => {
        // Do nothing.
      };
    }

    trackEvent(session, pathname, 'Page Viewed', {
      pathname,
      pageType,
      ...properties,
    });

    setTrackedPageView(pathname);

    return function cleanup() {
      setTrackedPageView(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

export default PageView;
